import { AlertCircle } from 'lucide-react';

export function AssessmentHelpNotifications({ 
  sectionCount, 
  questionCount
}: { 
  sectionCount: number; 
  questionCount: number;
}) {
  const show = sectionCount === 0 || questionCount === 0;
  
  let message = '';
  if (!sectionCount) {
    message = "Questions on an assessment are grouped into sections. Start filling out your assessment using the Add Section button below.";
  } else if (!questionCount) {
    message = "Now that you've added a section you can add questions to it. Select Add Question from the menu next to the section you want to populate.";
  }
  
  if (!show) return null;
  
  return (
    <div className="bg-action-blue/10 border border-action-blue/30 rounded-lg p-4 mb-4 flex items-start">
      <AlertCircle className="text-action-blue mr-3 mt-0.5 flex-shrink-0" size={20} />
      <p className="text-sm text-action-blue-dark">{message}</p>
    </div>
  );
}

